module.exports = __webpack_public_path__ + "img/ic-list-plus-da.3c19d8ec.svg";